var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOjo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.54 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b3b3b3;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.27,14c-2.43,0-4.79-1.18-6.85-3.4C.9,8.95.09,7.32.06,7.25c-.08-.16-.08-.34,0-.5.03-.07.84-1.7,2.37-3.35C4.48,1.18,6.84,0,9.27,0s4.79,1.18,6.85,3.4c1.52,1.65,2.33,3.28,2.37,3.35.08.16.08.34,0,.5-.03.07-.84,1.7-2.37,3.35-2.05,2.22-4.42,3.4-6.85,3.4ZM1.21,7c.64,1.15,3.55,5.86,8.06,5.86s7.42-4.71,8.06-5.86c-.64-1.15-3.55-5.86-8.06-5.86S1.85,5.85,1.21,7ZM.57,7h0,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.27,9.98c-1.62,0-2.94-1.34-2.94-2.98s1.32-2.98,2.94-2.98,2.94,1.34,2.94,2.98-1.32,2.98-2.94,2.98ZM9.27,5.16c-1,0-1.81.83-1.81,1.84s.81,1.84,1.81,1.84,1.81-.83,1.81-1.84-.81-1.84-1.81-1.84Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOjo);
export default __webpack_public_path__ + "static/media/OJO.2b33dccd82abced95ba2ed709fa3f70a.svg";
export { ForwardRef as ReactComponent };